<template>
    <div>
        <img v-for="image in images" :key="image.filename" :src="image.filename" />
    </div>
</template>

<script setup lang="ts">
import type { SbImage } from '@/components/StoryblokComponent.vue';

defineProps<{ images: SbImage[] }>();
</script>
